export default "__VITE_ASSET__Mo3NvO24__"